<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 35px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Lista de productos de compras</h2></v-toolbar-title></pre>
        </v-toolbar>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-if="rol != 4 && rol != 5"
                    fab
                    :to="{ path: `/guardar-producto-compra` }"
                    :loading="isloading"
                    :disabled="isloading"
                    color="orange darken-1"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text"
                        >mdi-account-plus-outline</v-icon
                    >
                </v-btn>
            </template>
            <span>Nuevo producto</span>
        </v-tooltip>
        <v-row>
            <v-col cols="12" md="4">
                <v-text-field
                    prepend-icon="mdi-account-search"
                    v-model="search"
                    label="Buscar por nombre o número"
                    placeholder="Nombre, número..."
                ></v-text-field>
            </v-col>
        </v-row>
        <v-data-table
            :item-class="
                () => {
                    return 'pointer';
                }
            "
            @click:row="
                (item) => {
                    if (rol != 4 && rol != 5)
                        $router.push(`/guardar-producto-compra?id=${item.id}`);
                }
            "
            dense
            :headers="headers"
            :items="Productos"
            :search="search"
            :server-items-length="total"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :sort-by="['nombre']"
            :sort-desc="[false]"
            @update:items-per-page="ChangeSize"
            @pagination="ChangePage"
        >
            <template v-slot:item.created_at="{ item }">
                <span>{{ item.created_at | format_date }}</span>
            </template>
            <template v-slot:item.precio="{ item }">
                <span>{{ item.precio | format_precio }}</span>
            </template>
            <template v-slot:item.action="{ item }">
                <a @click.stop="openModal(item)">
                    <v-icon
                        small
                        class="mr-2"
                        color="red"
                        style="font-size: 25px"
                        title="BORRAR"
                        >mdi-trash-can</v-icon
                    >
                </a>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteProducto()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import { debounce } from "../../../helpers";

export default {
    data() {
        return {
            search: "",
            page: 1,
            amount: 15,
            total: 0,

            Productos: [],
            selectedItem: 0,
            dialog: false,
        };
    },
    watch: {
        //
        search: debounce(function (val) {
            this.getProductos();
        }, 500),
    },
    created() {
        this.getProductos();
    },
    methods: {
        ChangeSize(event) {
            this.amount = event;
            this.getProductos();
        },
        ChangePage(event) {
            this.page = event.page;
            this.getProductos();
        },
        getProductos() {
            axios
                .get(
                    `api/get-productos-compra?page=${this.page}&amount=${this.amount}&search=${this.search}`
                )
                .then(
                    (res) => {
                        this.Productos = res.data.success.data;
                        this.total = res.data.success.total;
                    },
                    (err) => {
                        this.$custom_error("Error consultando los productos");
                    }
                );
        },
        openModal(item) {
            this.selectedItem = this.Productos.indexOf(item);
            this.dialog = true;
        },
        deleteProducto() {
            axios
                .delete(
                    `api/delete-producto-compra/${
                        this.Productos[this.selectedItem].id
                    }`
                )
                .then(
                    (res) => {
                        this.$toast.sucs(res.data.success);
                        this.dialog = false;
                        this.getProductos();
                    },
                    (err) => {
                        this.$custom_error(err.data.error);
                    }
                );
        },
    },
    computed: {
        isloading: function () {
            // return this.$store.getters.getloading
        },
        rol: function () {
            return localStorage.getItem("role");
        },
        headers: function () {
            let result = [
                { text: "Número", value: "nro", sortable: false },
                { text: "Nombre", value: "nombre", sortable: false },
                { text: "Precio", value: "precio", sortable: false },
                { text: "Proveedor", value: "proveedor", sortable: false },
            ];
            if (this.rol != 4 && this.rol != 5) {
                result.push({
                    text: "Acciones",
                    value: "action",
                    sortable: false,
                });
            }
            return result;
        },
    },
};
</script>
